module.exports = __webpack_public_path__ + "static/media/라.9609a102.jpg";